export const MAX_RESULT_FILES = 5;
export const MAX_RESULT_FILES_TOTAL_BYTES = 8 * 1024 * 1024;
export const ALLOWED_RESULT_MIMETYPES = [
  "image/jpeg",
  "image/png",
  "application/pdf",
];

export const normalizeText = (value) => (value || "").toString().trim();

export const getFilesTotalBytes = (files = []) =>
  files.reduce((total, item) => total + Number(item?.sizeBytes || item?.size || 0), 0);

export const createLocalResultFile = (file) => ({
  localId: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
  file,
  originalName: file?.name,
  mimetype: file?.type,
  sizeBytes: Number(file?.size || 0),
});

export const appendValidResultFiles = (
  currentFileList,
  incomingFiles,
  appointmentBytesOutsideResult = 0,
) => {
  const files = [...(currentFileList || [])];
  let totalBytes = getFilesTotalBytes(files);
  let validationError = "";

  for (const file of incomingFiles || []) {
    if (!ALLOWED_RESULT_MIMETYPES.includes((file?.type || "").toLowerCase())) {
      validationError = "Solo se admiten imagenes JPG, PNG o documentos PDF.";
      continue;
    }

    if (files.length >= MAX_RESULT_FILES) {
      validationError = `Solo se permiten ${MAX_RESULT_FILES} archivos por resultado.`;
      break;
    }

    const nextFileSize = Number(file?.size || 0);
    if (
      Number(appointmentBytesOutsideResult || 0) + totalBytes + nextFileSize >
      MAX_RESULT_FILES_TOTAL_BYTES
    ) {
      validationError = "El total de archivos de la cita no puede superar 8 MB.";
      continue;
    }

    files.push(createLocalResultFile(file));
    totalBytes += nextFileSize;
  }

  return { files, totalBytes, validationError };
};

export const isPdfResultFile = (file) => {
  const mimetype = normalizeText(file?.mimetype).toLowerCase();
  const originalName = normalizeText(file?.originalName).toLowerCase();
  return mimetype === "application/pdf" || originalName.endsWith(".pdf");
};
